import { useState, useEffect } from 'react'

type ScrollDetectorProps = {
  onBottom: () => void
  loading?: boolean
  scrollOffset?: number
  selector?: string
}

const ScrollDetector = ({
  onBottom,
  loading = false,
  scrollOffset = 50,
  selector,
}: ScrollDetectorProps) => {
  const [lastClick, setLastClick] = useState(Date.now())
  const [delay] = useState(300)

  useEffect(() => {
    try {
      const scrollSelector = selector
        ? document.querySelector(selector)
        : window

      scrollSelector?.addEventListener('scroll', handleScroll)
    } catch (e) {
      console.error(e)
    }

    return () => {
      try {
        const scrollSelector = selector
          ? document.querySelector(selector)
          : window

        scrollSelector?.removeEventListener('scroll', handleScroll)
      } catch (e) {
        console.error(e)
      }
    }
  })

  const handleScroll = () => {
    let reachedBottom = false

    if (!selector) {
      const windowHeight =
        'innerHeight' in window
          ? window.innerHeight
          : document.documentElement.offsetHeight

      const body = document.body

      const html = document.documentElement

      const docHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      )

      const windowBottom = windowHeight + window.pageYOffset + 200

      reachedBottom = windowBottom >= docHeight
    } else {
      const elem = document.querySelector<HTMLElement>(selector)

      reachedBottom = elem
        ? elem.scrollTop >= elem.scrollHeight - elem.offsetHeight - scrollOffset
        : false
    }

    if (
      !loading &&
      onBottom &&
      reachedBottom &&
      lastClick < Date.now() - delay
    ) {
      onBottom()
      setLastClick(Date.now())
    }
  }

  return null
}

export default ScrollDetector
